import { render, staticRenderFns } from "./AppModules.vue?vue&type=template&id=4faea594"
import script from "./AppModules.vue?vue&type=script&lang=js"
export * from "./AppModules.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports